import React from "react"


interface OwnProps {
  onButtonClick?: (platform: string) => void
  src: string;
  storeLink?: string;
}

type AppleButtonProps = OwnProps

export const AppleButton: React.FC<AppleButtonProps> = ({
  onButtonClick,
  src,
  storeLink
}) => {
  const AppImage = () => {
    return (
      <img
        alt="Apple App Store"
        height="39"
        src={src}
        width="116"
      />
    )
  };
  return (
    <>
      {storeLink && onButtonClick
        ? <a className="app-button inline-block align-middle mx-auto md:mx-0" href={storeLink} onClick={() => onButtonClick("Apple")}>
            <AppImage />
          </a>
        : <div className="app-button inline-block align-middle mx-auto md:mx-0">
            <AppImage />
          </div>
      }
    </>
  )
}
